import React from "react";
import { ContentBody } from 'areas/shared/components';
import { Box } from "fw/components";
import Search from './Search';
import CompanyInfoTab from './CompanyInfoTab';
import { SetupPage } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import APIDownload from 'fw/system/API';
import * as Formatter from 'fw/components/formatter/Formatter';

class ConnectToVOB extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false,
            selectedRows: []
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
    }

    onRowsSelectedChange = (selectedRows) => {
        // Selected
        this.setState({ selectedRows: selectedRows });
    }

    onExecutiveReportSummary = (rq) => {
        let selectedCertifications = [];
        this.state.selectedRows.forEach(r => {
            selectedCertifications.push(r.certificationId);
        });

        const exportRq = {
            sortField: rq.sortField,
            sortDirection: rq.sortDirection,
            selectedCertifications: selectedCertifications
        };

        API.Sponsor.post('/sponsorSetup/SearchConnectVOBexport', exportRq, {
            success: (sr) => {
                new APIDownload().download(sr.data);
            }
        });
    }

    render() {
        let opts = {
            setupKey: "companySetup",
            title: "Connect to Veteran Owned Business - ",
            description: "Search for Certified Veteran Owned Business within VOCS",
            enableColumnSettings: true,
            customAction: { title: 'VOB Export', onExecute: this.onExecutiveReportSummary, disabled: (this.state.selectedRows.length === 0) },
            recentType: "sponsor",
            enableExport: false,
            showTitle: false,
            showButtons: {
                cancel: false,
                save: false
            },
            list: {
                url: API.Sponsor.url('/sponsorSetup/searchConnectVOB'),
                rowKey: "certificationId",
                columns: [
                    { key: 'vobName', name: 'Company Name', width: 160, sortable: true },
                    { key: 'vobFein', name: 'FEIN/EIN', width: 85, sortable: true },
                    { key: 'veteranOwner', name: 'Veteran Name', width: 160, sortable: true },
                    { key: 'naicsCodes', name: 'NAICS Code(s)', width: 180, sortable: false },
                    { key: 'stateCode', name: 'State', width: 62, sortable: true },
                    { key: 'geographicMarketName', name: 'Geo Market', width: 100, sortable: true },
                    { key: 'employees', name: 'Employees', width: 97, sortable: true },
                    { key: 'sdvs', name: 'SDVS', width: 62, sortable: true },
                    { key: 'grossRevenue1Amount', name: 'Revenue', width: 92, formatter: Formatter.CurrencyWithoutDecimals, sortable: true },
                    { key: 'businessOwnershipName', name: 'Ownership', width: 125, sortable: true },
                    { key: 'businessCertifications', name: 'Accreditation/Certification', width: 200, sortable: false }
                ]
            },
            tabs: [
                { key: "companyInfo", title: "Company Info", comp: CompanyInfoTab }
            ]
        };

        return (
            <React.Fragment>
                <ContentBody>
                    <Box>
                        <SetupPage 
                            {...opts} 
                            enableRowSelection={true}
                            maxRowSelection={10}
                            rowSelectionTooltip="Please select at least 1 row to enable the VOB Export feature. Please keep in mind, you will not be able to select more than 10 businesses at a time"
                            onRowsSelectedChange={this.onRowsSelectedChange}
                            Search={Search} />
                    </Box>
                </ContentBody>
            </React.Fragment >
        );
    }
}

export default ConnectToVOB;



// WEBPACK FOOTER //
// ./src/areas/sponsor/connectToVOB/ConnectToVOB.js